import { registerRemotes } from '@module-federation/runtime';

async function validateManifest(url: string) {
    try {
        const response = await fetch(url, { method: 'GET', cache: 'no-cache' });
        if (!response.ok) return false;
        await response.json();
        return true;
    } catch {
        return false;
    }
}

type InitMfPayload = {
    remoteSourceName: string;
    remoteSourceUrl?: string;
    fallbackUrl?: string;
};

export async function initMF(payload: InitMfPayload) {
    const { promise, resolve, reject } = Promise.withResolvers();
    try {
        const candidates = [
            payload.remoteSourceUrl,
            payload.fallbackUrl
        ].filter(Boolean);

        let manifestUrl: string | undefined;
        for (const url of candidates) {
            const candidateManifest = `${url}/mf-manifest.json`;
            if (await validateManifest(candidateManifest)) {
                manifestUrl = candidateManifest;
                break;
            }
        }

        if (!manifestUrl) {
            throw new Error('No valid remote manifest found');
        }

        registerRemotes(
            [{ name: payload.remoteSourceName, entry: manifestUrl }],
            {
                force: true
            }
        );

        resolve(`Module Federation ${payload.remoteSourceName} initialized`);
    } catch (error) {
        reject(error);
    }
    return promise;
}
